import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Badge,
  Select,
  TreeSelect,
  Button
} from "antd";
import cloneDeep from "lodash/cloneDeep";

import classes from "./DocumentsPublic.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDocumentsValidationSearchRequest,
  getEtmfDocumentSchemaFilterRequest,
  getEtmfDocumentSchemaRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import FileLink from "../../components/FileLink/FileLink";
import FolderView from "../DocumentsEditor/FolderView";

import { getDimensionWidth } from "../../reducers/dimensions/selectors";
import { getDocumentManagementTableExcludedCols } from "../../reducers/document_management/selectors";
import { documentManagementTableColsUpdate } from "../../reducers/document_management/actions";
import TableColsFilter from "../DocumentsEditor/TableColsFilter";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { TreeNode } = TreeSelect;
const ButtonGroup = Button.Group;

class DocumentsValidation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: "order_index", order: "ascend" },
      documentEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      etmfSchema: {},
      etmfSchemaFilter: {},
      contentTypeCode: null,
      view: "table",
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    this.getETMFSchema();
  }

  getETMFSchema = async () => {
    try {
      const { data: etmfSchema } = await getEtmfDocumentSchemaRequest();
      const {
        data: etmfSchemaFilter,
      } = await getEtmfDocumentSchemaFilterRequest("validation");

      this.setState({ etmfSchema, etmfSchemaFilter });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filter: null,
        site: null,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getDocuments
    );
  };

  getDocuments = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getDocumentsValidationSearchRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          documents: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          documents: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        documents: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getDocuments(pagination.current, pagination.pageSize)
    );
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState((state) => {
      let filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = value;

      if (!filtersValue[index] || !filtersValue[index].length) {
        filtersValue = [];
      }
      return { filtersValue, currentPage: 1 };
    }, this.getDocuments);
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getDocuments);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getDocuments);
  };

  renderFilterItem = ({ index = this.state.filtersBy.length, viewType }) => {
    const { filtersBy, filtersValue, etmfSchemaFilter, sites } = this.state;

    return !(
      viewType === "folderView" && filtersBy[index] === "content_type_code"
    ) ? (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Filter by")}
            </b>
            <Select
              onChange={this.handleFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {viewType !== "folderView" && (
                <Option
                  value="content_type_code"
                  disabled={filtersBy.includes("content_type_code")}
                >
                  {this.props.i18n.t("Content type")}
                </Option>
              )}
              <Option
                value="extension"
                disabled={filtersBy.includes("extension")}
              >
                {this.props.i18n.t("Extension")}
              </Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === "content_type_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Content type")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("Select content type")}
              style={{ width: "100%" }}
              allowClear
            >
              {get(etmfSchemaFilter, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                    sub_categories.length > 0 &&
                    sub_categories.map(({ name, code, content_types }) => (
                      <TreeNode
                        key={code}
                        title={<b style={{ color: "#777" }}>{name}</b>}
                        value={code}
                        selectable={false}
                      >
                        {content_types &&
                        content_types.length > 0 &&
                        content_types.map(({ name, code }) => (
                          <TreeNode key={code} title={name} value={code} />
                        ))}
                      </TreeNode>
                    ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}

        {filtersBy[index] === "extension" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Extension")}</b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
              showSearch
              optionFilterProp="children"
              filterOption
            >
              <Option value="docx">.docx</Option>
              <Option value="xlsx">.xlsx</Option>
              <Option value="pptx">.pptx</Option>
              <Option value="pdf">.pdf</Option>
              <Option value="odt">.odt</Option>
              <Option value="csv">.csv</Option>
              <Option value="txt">.txt</Option>
              <Option value="png">.png</Option>
              <Option value="jpg">.jpg</Option>
              <Option value="gif">.gif</Option>
              <Option value="mp4">.mp4</Option>
              <Option value="eml">.eml</Option>
              <Option value="msg">.msg</Option>
              <Option value="zip">.zip</Option>
              <Option value="xls">.xls</Option>
              <Option value="doc">.doc</Option>
              <Option value="ppt">.ppt</Option>
              <Option value="vsdx">.vsdx</Option>
              <Option value="xlsm">.xlsm</Option>
              <Option value="xlsx">.xlsx</Option>
              <Option value="accdb">.accdb</Option>
            </Select>
          </label>
        )}

        {filtersValue[index] &&
        !(
          viewType === "folderView" &&
          filtersBy[index] === "content_type_code"
        ) && (
          <span
            className={classes.clearButton}
            onClick={this.clearFilter(index)}
          >
              {this.props.i18n.t("Remove")}
            </span>
        )}
      </div>
    ) : (
      <div key={filtersBy[index]} />
    );
  };

  clearContentTypeCode = () => {
    this.setState({
      contentTypeCode: null,
    });
  };

  setContentTypeCode = (contentTypeCode) => {
    this.setState(
      () => {
        const filtersContentTypeIndex = this.state.filtersBy.findIndex(
          (item) => item === "content_type_code"
        );
        const filtersBy = [...this.state.filtersBy];
        const filtersValue = [...this.state.filtersValue];

        if (filtersContentTypeIndex !== -1) {
          filtersBy.splice(filtersContentTypeIndex, 1);
          filtersValue.splice(filtersContentTypeIndex, 1);
        }

        return {
          contentTypeCode,
          documents: [],
          currentPage: 1,
          filtersBy: ["content_type_code", ...filtersBy],
          filtersValue: [contentTypeCode, ...filtersValue],
        };
      },
      () => {
        if (contentTypeCode) {
          this.getDocuments();
        }
      }
    );
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      documents,
      currentPage,
      total,
      pageSize,
      sortedInfo,
      filtersBy,
      etmfSchemaFilter,
      etmfSchema,
      view,
    } = this.state;

    let columns = [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: this.props.i18n.t("Index"),
        render: (val) => <span>{val}</span>,
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "order_index" && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("Document Name"),
        render: (val, record) => (
          <div className={classes.nameDocumentWrapper}>
            <div style={{ width: "86px" }}>
              <Badge
                count={record.state}
                style={{
                  backgroundColor:
                    record.state === "active" ? "#52c41a" : "#777",
                }}
              />
              <br />
              {record.state === "active" && (
                <Badge
                  count={record.approved ? "approved" : "unapproved"}
                  style={{
                    backgroundColor: record.approved ? "#52c41a" : "#777",
                  }}
                />
              )}
            </div>
            {val}
          </div>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "name" && sortedInfo.order,
      },
      {
        dataIndex: "extension",
        key: "extension",
        title: this.props.i18n.t("Extension"),
        render: (val) => <span>{val}</span>,
      },
      {
        dataIndex: "content_type_name",
        key: "content_type_name",
        title: this.props.i18n.t("Content type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "content_type_name" &&
          sortedInfo.order,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        render: (site) => get(site, "name"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: this.props.i18n.t("Start date"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "start_year" && sortedInfo.order,
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: this.props.i18n.t("Expiry date"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "expiry_year" && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, document) => (
          <div className={classes.actions}>
            <FileLink url={document.url} />
          </div>
        ),
      },
    ];

    if (this.props.dimensionWidth < 768) {
      const contentTypeIndex = columns.findIndex(({ key }) => key === 'content_type_name');

      if (!!~contentTypeIndex) {
        columns = [columns[1], columns[contentTypeIndex], columns[columns.length - 1]];
      } else {
        columns = [columns[1], columns[columns.length - 1]];
      }
    }

    const columnsFiltered = cloneDeep(columns);

    Object.keys(this.props.documentManagementTableExcludedCols).forEach(
      (item) => {
        if (this.props.documentManagementTableExcludedCols[item]) {
          if (!!~columnsFiltered.findIndex(({ key }) => key === item)) {
            columnsFiltered.splice(
              columnsFiltered.findIndex(({ key }) => key === item),
              1
            );
          }
        }
      }
    );

    columnsFiltered[columnsFiltered.length - 1].title = (
      <div className={classes.actionCol}>
        <div style={{ marginRight: '15px' }}>{this.props.i18n.t("Actions")}</div>

        <TableColsFilter
          documentManagementTableExcludedCols={this.props.documentManagementTableExcludedCols}
          documentManagementTableColsUpdate={this.props.documentManagementTableColsUpdate}
          columns={columns}
        />
      </div>
    );

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Validation Documents")}
            </h3>

            <div style={{ margin: "20px 0" }}>
              <ButtonGroup>
                <Button
                  type={view === "table" ? "primary" : "secondary"}
                  onClick={() => {
                    this.setState(
                      {
                        nameSearch: null,
                        view: "table",
                        documents: null,
                        currentPage: 1,
                        filtersBy: ["content_type_code"],
                        filtersValue: [],
                      },
                      this.getDocuments
                    );
                  }}
                >
                  {view === "table" && <Icon type="check-circle" />}
                  {this.props.i18n.t("Table view")}
                </Button>
                <Button
                  type={view === "folder" ? "primary" : "secondary"}
                  onClick={() => {
                    this.setState({
                      nameSearch: null,
                      view: "folder",
                      currentPage: 1,
                      filtersBy: [],
                      filtersValue: [],
                      contentTypeCode: null,
                    }, () => { this.getETMFSchema(); this.getDocuments(); });
                  }}
                >
                  {view === "folder" && <Icon type="check-circle" />}
                  {this.props.i18n.t("Folder view")}
                </Button>
              </ButtonGroup>
            </div>

            {view === "folder" && (
              <FolderView
                documentCreatePermission={false}
                etmfSchema={etmfSchema}
                etmfSchemaFilter={etmfSchemaFilter}
                addDocumentWithParams={false}
                setContentTypeCode={this.setContentTypeCode}
                clearContentTypeCode={this.clearContentTypeCode}
                filters={
                  <div className={classes.wrapperFilters}>
                    <h4 className="headline-default">
                      {this.props.i18n.t("Filter")}
                    </h4>

                    <div className={classes.wrapperFilters}>
                      {filtersBy.map((_, index) =>
                        this.renderFilterItem({ index, viewType: "folderView" })
                      )}

                      {filtersBy.length === this.state.filtersValue.length &&
                      filtersBy.length !== 2 &&
                      this.renderFilterItem({ viewType: "folderView" })}
                    </div>
                  </div>
                }
              />
            )}

            {view === "table" && (
              <div>
                <div className={classes.searchWrapper}>
                  <label className={classes.searchWrapperSearch}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("SEARCH")}
                    </b>
                    <Search
                      placeholder={this.props.i18n.t("By name")}
                      enterButton={this.props.i18n.t("Search")}
                      size="large"
                      onSearch={this.onNameSearch}
                      value={nameSearch}
                      onChange={this.onNameChange}
                      style={{ maxWidth: "500px" }}
                    />
                  </label>
                </div>

                <h4 className="headline-default">
                  {this.props.i18n.t("Filter")}
                </h4>

                <div className={classes.wrapperFilters}>
                  {filtersBy.map((_, index) =>
                    this.renderFilterItem({ index })
                  )}

                  {filtersBy.length === this.state.filtersValue.length &&
                  filtersBy.length !== 2 &&
                  this.renderFilterItem({})}
                </div>

                {errorMessage && <Alert type="error" message={errorMessage} />}

                {responseMessage && (
                  <Alert type="success" message={responseMessage} />
                )}
              </div>
            )}

            {(view === "table" || this.state.contentTypeCode) && (
              <Table
                columns={columnsFiltered}
                dataSource={documents}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: 'both',
                }}
              />
            )}

            {isLoading && <Icon type="loading" />}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dimensionWidth: getDimensionWidth(state),
  documentManagementTableExcludedCols: getDocumentManagementTableExcludedCols(
    state
  ),
});
const mapDispatchToProps = { logout, documentManagementTableColsUpdate };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentsValidation))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentsPublic/DocumentsValidation.js